<div class="status-row" [class.ready]="projectActivity.ready">
	<div class="activity-row">
		<div class="icon-title">
			<div class="status-icon" *ngIf="projectActivity.startDate" (click)="toggleReady()">
				<mat-icon>done</mat-icon>
			</div>
		</div>
		<div class="activity-info-block" (click)="editProjectActivity()">
			<div class="status-title">

				<div class="manual-control" *ngIf="projectActivity.manualControl">M</div>
				{{projectActivity.type.title}}

        <i class="pi pi-paperclip" style="font-size: 100%" *ngIf="projectActivity.files?.length > 3"></i>
        <ng-container *ngIf="projectActivity.files?.length <= 3">
          <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let file of projectActivity.files"
             (click)="openFile($event, file)"></i>
        </ng-container>

				<i class="pi pi-exclamation-triangle" style="font-size: 120%" *ngIf="projectActivity.overlaps"
					pTooltip="Overlap with activity" tooltipPosition="bottom"></i>
			</div>

			<div class="status-date duration" *ngIf="hours">

				<span class="span-date">
					<span *ngIf="projectActivity.user"
						class="manual-control user-tooltip">{{projectActivity.user.shortCode}}</span>
					{{hours}}</span>
			</div>
			<div class="status-date start-date" *ngIf="projectActivity.startDate"><span
					class="span-date">{{projectActivity.startDate | date:'MMM d, y'}}</span></div>
			<div class="status-date start-time" *ngIf="projectActivity.startDate">
				<span class="span-date"	*ngIf="!projectActivity.ignoreTime">{{projectActivity.startDate | date:'h:mm a'}}</span>
				<span class="span-date tire-date" *ngIf="projectActivity.ignoreTime">-</span>
			</div>
			<div class="status-date" *ngIf="!projectActivity.startDate"><span class="span-date">No Date</span></div>
		</div>
	</div>
</div>
